import { useState } from "react";
import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import "./NFTMarketplace.css";
import ServiceFooter from "../../ServiceFooter";
import nftMrkt_keyFct_itmImg1 from '../../../image/NFTMarketplaceNew/nftMrkt_keyFct_itmImg1.webp'
import nftMrkt_keyFct_itmImg2 from '../../../image/NFTMarketplaceNew/nftMrkt_keyFct_itmImg2.webp'
import nftMrkt_keyFct_itmImg3 from '../../../image/NFTMarketplaceNew/nftMrkt_keyFct_itmImg3.webp'
import nftMrkt_keyFct_itmImg4 from '../../../image/NFTMarketplaceNew/nftMrkt_keyFct_itmImg4.webp'
import nftMrkt_keyFct_itmImg5 from '../../../image/NFTMarketplaceNew/nftMrkt_keyFct_itmImg5.webp'
import nftMrkt_keyFct_itmImg6 from '../../../image/NFTMarketplaceNew/nftMrkt_keyFct_itmImg6.webp'
import nftMrkt_keyFct_itmImg7 from '../../../image/NFTMarketplaceNew/nftMrkt_keyFct_itmImg7.webp'
import nftMrkt_keyFct_itmImg8 from '../../../image/NFTMarketplaceNew/nftMrkt_keyFct_itmImg8.webp'
import nftMrkt_keyFct_itmImg9 from '../../../image/NFTMarketplaceNew/nftMrkt_keyFct_itmImg9.webp'
import nftMrkt_keyFct_itmBck from '../../../image/NFTMarketplaceNew/nftMrkt_keyFct_itmBck.webp'
import nftMrkt_keyFct_prevImg from '../../../image/NFTMarketplaceNew/nftMrkt_keyFct_prevImg.webp'
import nftMrkt_keyFct_nextImg from '../../../image/NFTMarketplaceNew/nftMrkt_keyFct_nextImg.webp'
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";
import CircularCarousel from "./CircularCarousel";
import { IoArrowForwardSharp } from "react-icons/io5";
import MyFAQPage from "../../Scema/Nftscema";

const NFTMarketplace = () => {

    const [keyFeaturesActive, setKeyFeaturesActive] = useState(1)
    const [keyFeaturesNumber, setKeyFeaturesNumber] = useState(1)

    const keyFeatures = [
        {
            id:1,
            heading:'User-Friendly Interface',
            description:'UI is a key factor in the NFT Marketplace. Our User interface includes all sorts of features like a sorting option, a search filter, and more.',
            img:nftMrkt_keyFct_itmImg1,
        },
        {
            id:2,
            heading:'Multiple Wallet',
            description:'Our NFT marketplace includes multiple wallet support for managing and storing NFTs and cryptocurrencies.',
            img:nftMrkt_keyFct_itmImg2,
        },
        {
            id:3,
            heading:'Multi-chain interoperability',
            description:'Users can trade NFT over a variety of blockchain networks because the platform offers multi-chain interoperability.',
            img:nftMrkt_keyFct_itmImg3,
        },
        {
            id:4,
            heading:'Secure Payment Gateway',
            description:'Users can make transactions and payments through our payment gateway integration with high security.',
            img:nftMrkt_keyFct_itmImg4,
        },
        {
            id:5,
            heading:'Staking',
            description:'The NFT staking model allows users to stake their NFTs in the platform for a set period of time, allowing them to earn rewards.',
            img:nftMrkt_keyFct_itmImg5,
        },
        {
            id:6,
            heading:'Buying and Auction',
            description:'Users can create and manage auctions easily. And can create a dynamic marketplace environment that enhances engagement and value.',
            img:nftMrkt_keyFct_itmImg6,
        },
        {
            id:7,
            heading:'Token Search',
            description:'Enable users to search for specific tokens within your marketplace, making it convenient for collectors and investors to find their desired NFTs.',
            img:nftMrkt_keyFct_itmImg7,
        },
        {
            id:8,
            heading:'Smart Contract Integration',
            description:'Integrate smart contracts for secure, transparent, and automated transactions in your NFT marketplace.',
            img:nftMrkt_keyFct_itmImg8,
        },
        {
            id:9,
            heading:'Burning/Minting',
            description:'To manage the supply of the NFTs, users can mint and burn their tokens with the minting and burning option.',
            img:nftMrkt_keyFct_itmImg9,
        },
    ]

    const handlePrev = () => {
        setKeyFeaturesActive((prev) =>
            prev === 1 ? keyFeatures.length : prev - 1
        );
    };

    const handleNext = () => {
        setKeyFeaturesActive((prev) =>
            prev === keyFeatures.length ? 1 : prev + 1
        );
    };

    return (
        <>
            <NewHead />

            <Helmet>
                    <title>
                      NFT Marketplace Development Company | NFT Marketplace Development
                      Services
                    </title>
                    <link
                      rel="canonical"
                      href="https://www.beleaftechnologies.com/nft-marketplace-development-service"
                    />
                    <meta name="title" content=" NFT Marketplace Development Services" />
                    <meta
                      name="description"
                      content="We are experts in providing cost-efficient and customized NFT marketplace development services and solutions with high-security features and functionalities. 
                            "
                    />
                    <meta
                      name="keywords"
                      content="NFT marketplace development company, nft marketplace development services, nft marketplace development solutions, create your own nft marketplace, nft marketplace development services, White label nft marketplace development company, Create your own NFT marketplace, non fungible token development company
                                "
                    />
                    <meta
                      property="og:title"
                      content=" NFT Marketplace Development Service Providing Company
                            "
                    />
                    <meta
                      property="og:site_name"
                      content="Beleaf Technologies - NFT Marketplace Development Company"
                    />
                    <meta
                      property="og:url"
                      content="https://www.beleaftechnologies.com/nft-marketplace-development-service"
                    />
                    <meta
                      property="og:description"
                      content="Beleaf Technologies is an NFT Marketplace development company offering a top-notch customized NFT marketplace development solutions with advanced features and functionalities."
                    />
                    <meta property="og:type" content="website" />
            
                    <meta
                      name="author"
                      content="Beleaf Technologies - Blockchain development Company"
                    ></meta>
                    <meta name="twitter:card" content="summary" />
                    <meta name="twitter:site" content="@BeleafTech" />
                    <meta
                      name="twitter:title"
                      content="NFT Marketplace Development Company | NFT Marketplace Development Services"
                    />
                    <meta
                      name="twitter:description"
                      content="As a leading NFT Marketplace development company, Beleaf technology offers custom NFT Marketplace development services and solutions. Hire our NFT marketplace developers to launch a cutting-edge NFT marketplace with numerous security levels, first-rate features, and functionality."
                    />
            
                    <meta name="twitter:image:alt" content="Beleaf Technologies" />
                    <MyFAQPage />
                  </Helmet>

            <main className="nftMrktMainWrp">

                {/* section 1 */}

                <article className='nftMrkt_hero_sct nftMrkt_commn_sct'>
                    <img className="sectionOneBackImg" src={new URL("../../../image/NFTMarketplaceNew/sectionOneBackImg.webp", import.meta.url)} />
                    <div className='nftMrkt_hero_cont nftMrkt_commn_cont primary__landing__container'>
                        <div className='nftMrkt_hero_wrp'>
                            <div className='nftMrkt_hero_ContTop'>
                                <h1>
                                    <span>NFT Marketplace</span> Development service
                                </h1>
                                <p>
                                    Launch your NFT Marketplace with our adroit team of NFT marketplace developers.
                                    We develop with multiple blockchain support and advanced features.
                                    Buy, sell, trade, and mint your NFTs with our customizable NFT marketplace.
                                </p>
                                <button
                                data-toggle="modal" data-target="#myModal"
                                    style={{
                                        border: "none", borderRadius: 999,
                                        color: "#fff", fontSize: 13, fontWeight: 600,
                                        padding: "11px 28px", cursor: "pointer",
                                        whiteSpace: "nowrap",
                                        boxShadow: "0 0 28px rgba(168,85,247,0.45)",
                                    }}
                                    className="getFreeConstlBtn getFreeConstlBtnmobl"
                                >
                                    Get Free Consultation
                                </button>
                            </div>
                            <div className='nftMrktHeroImg'>

                                <CircularCarousel />
                            </div>
                        </div>
                    </div>
                </article>

                {/* section 2 */}

                <article className='nftMrkt_secnd_sct nftMrkt_commn_sct'>
                    <div className='nftMrkt_secnd_cont nftMrkt_commn_cont primary__landing__container'>
                        <div className='nftMrkt_secnd_wrp'>
                            <div className='nftMrkt_secnd_rgt'>
                                <img src={new URL("../../../image/NFTMarketplaceNew/nftMrktOurImg.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                            </div>
                            <div className='nftMrkt_secnd_lft'>
                                <h2 className='nftMrkt_common_title'>
                                    <span> Our White Label NFT Marketplace </span> Development Solution
                                </h2>
                                <p className='nftMrkt_common_desp'>
                                    Beleaf Technologies offers a ready-to-deploy, Whitelabel NFT marketplace with advanced features and 
                                    customizable solutions. Our NFT Marketplace development solution provides high security and scalability 
                                    where NFT users can collect, buy, sell, and trade NFT.
                                </p>
                                <button className='nftMrkt_common_Btn2 nftMrkt_contactUs_Btn' data-toggle="modal" data-target="#myModal">
                                        <span className='nftMrkt_common_Btn2Txt'>Get a Demo</span>
                                        <span className='nftMrkt_common_Btn2Icon'>
                                            <img className="nftMrkt_common_Btn2Icon1" src={new URL("../../../image/NFTMarketplaceNew/btn2Arrow1.webp",import.meta.url)} alt="" />
                                            <img className="nftMrkt_common_Btn2Icon2" src={new URL("../../../image/NFTMarketplaceNew/btn2Arrow2.webp",import.meta.url)} alt="" />
                                        </span>
                                    </button>

                            </div>
                        </div>
                    </div>
                </article>

                {/* section 3 */}

                <article className='nftMrkt_benfts_sct nftMrkt_commn_sct'>
                    <div className='nftMrkt_benfts_cont nftMrkt_commn_cont primary__landing__container'>
                        <div className='nftMrkt_benfts_wrp'>
                            <h2 className='nftMrkt_common_title'>
                                    <span> Benefits </span> of Our NFT Marketplace Development
                            </h2>

                            <div className="nftMrkt_benfts_lst">
                                <div className="nftMrkt_benfts_lstItm nftMrkt_benfts_lstItmSm">
                                    <div className="nftMrkt_benfts_ItmCrcl">
                                        <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_benfts_Itm1.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                    </div>
                                    <h3>Transparency</h3>
                                    <p>
                                        With blockchain technology, all the transactions of NFT are 
                                        transparent and stored in a distributed ledger.
                                    </p>
                                </div>
                                <div className="nftMrkt_benfts_lstItm nftMrkt_benfts_lstItmLg">
                                    <div className="nftMrkt_benfts_ItmCrcl">
                                        <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_benfts_Itm2.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                    </div>
                                    <h3>Decentralization</h3>
                                    <p>
                                        Our NFT marketplace is Decentralized where users trade 
                                        assets directly without intermediaries.
                                    </p>
                                </div>
                                <div className="nftMrkt_benfts_lstItm nftMrkt_benfts_lstItmSm">
                                    <div className="nftMrkt_benfts_ItmCrcl">
                                        <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_benfts_Itm3.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                    </div>
                                    <h3>Secure</h3>
                                    <p>
                                        Blockchain technology makes the NFT Marketplace more 
                                        secure and protects users' data from hacking.
                                    </p>
                                </div>
                                <div className="nftMrkt_benfts_lstItm nftMrkt_benfts_lstItmLg">
                                    <div className="nftMrkt_benfts_ItmCrcl">
                                        <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_benfts_Itm4.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                    </div>
                                    <h3>Cross-chain Compatability and Interoperability</h3>
                                    <p>
                                        We enable two or more blockchain networks to facilitate interoperability.
                                    </p>
                                </div>
                                <div className="nftMrkt_benfts_lstItm nftMrkt_benfts_lstItmSm">
                                    <div className="nftMrkt_benfts_ItmCrcl">
                                        <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_benfts_Itm5.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                    </div>
                                    <h3>Liquidity</h3>
                                    <p>
                                        As the demand for NFTs surges, liquidity emerges as a fundamental force.
                                    </p>
                                </div>
                                <div className="nftMrkt_benfts_lstItm nftMrkt_benfts_lstItmSm">
                                    <div className="nftMrkt_benfts_ItmCrcl">
                                        <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_benfts_Itm6.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                    </div>
                                    <h3>Smart Contract</h3>
                                    <p>
                                        To process auctions, buy, and sell, we utilize smart contracts in our NFT marketplace platform.
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </article>

                {/* section 4 */}

                <article className='nftMrkt_keyFct_sct nftMrkt_commn_sct'>
                    <div className='nftMrkt_keyFct_cont nftMrkt_commn_cont primary__landing__container'>
                        <div className='nftMrkt_keyFct_wrp'>
                            <h2 className='nftMrkt_common_title'>
                                <span> Key Features </span> of Our NFT Marketplace Development Services
                            </h2>

                            <div className="nftMrkt_keyFct_lst">
                                {
                                    keyFeatures.map((item, index) => {
                                        return (
                                            <div key={index} onClick={() => {setKeyFeaturesActive(index+1);setKeyFeaturesNumber(index+1)}} 
                                            className={`nftMrkt_keyFct_itm ${keyFeaturesActive == (index+1) ? 'nftMrkt_keyFct_itmAct' : ''} ${'nftMrkt_keyFct_itmAct'+index}`}>
                                                <span>0{item.id}</span>
                                                <img className="nftMrkt_keyFct_itmItm" src={item.img} alt='nft-marketplace-development-service' />
                                                <img className="nftMrkt_keyFct_itmBck" src={nftMrkt_keyFct_itmBck} />
                                                <h3>{item.heading}</h3>
                                                <p>{item.description}</p>
                                            </div>
                                        )
                                    })
                                }
                            </div>

                            <div className="nftMrkt_keyFct_itmArrwWrp">
                                <div className="nftMrkt_keyFct_itmArr">
                                    <button
                                        onClick={handlePrev}
                                        className="nftMrkt_keyFct_prevArr"
                                    >
                                        <IoIosArrowBack />
                                    </button>

                                    <button
                                        onClick={handleNext}
                                        className="nftMrkt_keyFct_nextArr"
                                    >
                                        <IoIosArrowForward />
                                    </button>
                                </div>
                                <button className='nftMrkt_common_Btn2 nftMrkt_contactUs_Btn' data-toggle="modal" data-target="#myModal">
                                        <span className='nftMrkt_common_Btn2Txt'>Free Demo</span>
                                        <span className='nftMrkt_common_Btn2Icon'>
                                            <img className="nftMrkt_common_Btn2Icon1" src={new URL("../../../image/NFTMarketplaceNew/btn2Arrow1.webp",import.meta.url)} alt="" />
                                            <img className="nftMrkt_common_Btn2Icon2" src={new URL("../../../image/NFTMarketplaceNew/btn2Arrow2.webp",import.meta.url)} alt="" />
                                        </span>
                                    </button>
                            </div>

                        </div>
                    </div>
                </article>

                {/* section 5 */}

                <article className='nftMrkt_ourNft_sct nftMrkt_commn_sct'>
                    <div className='nftMrkt_ourNft_cont nftMrkt_commn_cont primary__landing__container'>
                        <div className='nftMrkt_ourNft_wrp'>
                            <h2 className='nftMrkt_common_title'>
                                    <span> Our NFT Marketplace Development Services </span>
                            </h2>
                            <p className='nftMrkt_common_desp'>
                                Our expertise in NFT development services to create and launch your own digital assets. 
                                Open-up new opportunities in the world of NFTs with Beleaf Technologies
                            </p>

                            <div className="nftMrkt_ourNft_lst">
                                <div className="nftMrkt_ourNft_itmOneWrp nftMrkt_ourNft_itmWrp">
                                    <div className="nftMrkt_ourNft_itmOne">
                                        <div className="nftMrkt_ourNft_itmSpan">
                                            <span>01</span>
                                            <h3>NFT Development</h3>
                                        </div>
                                        <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_ourNft_itmImg1.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                        <p className="nftMrkt_ourNft_itmDescp">Create your own NFT whether it is digital art, music, or an asset.</p>
                                    </div>
                                    <div className="nftMrkt_ourNft_itmOne">
                                        <div className="nftMrkt_ourNft_itmSpan">
                                            <span>02</span>
                                            <h3>NFT Smart Contract Audit</h3>
                                        </div>
                                        <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_ourNft_itmImg2.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                        <p className="nftMrkt_ourNft_itmDescp">Our smart contract developers offer comprehensive NFT smart contract audit services to ensure compliance and security.</p>
                                    </div>
                                </div>
                                <div className="nftMrkt_ourNft_itmTwoWrp nftMrkt_ourNft_itmWrp">
                                    <div className="nftMrkt_ourNft_itmTwo">
                                        <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_ourNft_itmImg3.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                        <div className="nftMrkt_ourNft_itmSpan">
                                            <span>03</span>
                                            <h3>NFT Marketplace Development</h3>
                                        </div>
                                        <p className="nftMrkt_ourNft_itmDescp">Beleaf's team creates NFT Marketplaces that provide a delightful trading experience of NFT to users all over the world.</p>
                                    </div>
                                </div>
                                <div className="nftMrkt_ourNft_itmThreeWrp nftMrkt_ourNft_itmWrp">
                                    <div className="nftMrkt_ourNft_itmThree">
                                        <div className="nftMrkt_ourNft_itmSpan">
                                            <span>04</span>
                                            <h3>NFT Marketplace App Development</h3>
                                        </div>
                                        <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_ourNft_itmImg4.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                        <p className="nftMrkt_ourNft_itmDescp">Perfectly buy, sell, and trade NFTs on a user-friendly mobile platform.</p>
                                    </div>
                                    <div className="nftMrkt_ourNft_itmThree">
                                        <div className="nftMrkt_ourNft_itmSpan">
                                            <span>05</span>
                                            <h3>NFT Marketplace Upgradation & Maintenance</h3>
                                        </div>
                                        <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_ourNft_itmImg5.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                        <p className="nftMrkt_ourNft_itmDescp">Ensure optimal performance, security, and scalability.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </article>

                {/* section 6 */}

                <article className='nftMrkt_varsFct_sct nftMrkt_commn_sct'>
                    <div className='nftMrkt_varsFct_cont nftMrkt_commn_cont primary__landing__container'>
                        <div className='nftMrkt_varsFct_wrp'>
                            <div className="nftMrkt_varsFct_cntWrp">
                                <div className="nftMrkt_varsFct_cntLft">
                                    <h2 className='nftMrkt_common_title'>
                                        NFT Marketplace development <span>For various factor</span>
                                    </h2>
                                    <ul className="nftMrkt_varsFct_cntLst">
                                        <li className="nftMrkt_varsFct_cntLstItm">
                                            <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_varsFct_lstItmImg1.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                            <span>Games</span>
                                        </li>
                                        <li className="nftMrkt_varsFct_cntLstItm">
                                            <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_varsFct_lstItmImg2.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                            <span>Art</span>
                                        </li>
                                        <li className="nftMrkt_varsFct_cntLstItm">
                                            <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_varsFct_lstItmImg3.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                            <span>Digital Collectables</span>
                                        </li>
                                        <li className="nftMrkt_varsFct_cntLstItm">
                                            <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_varsFct_lstItmImg4.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                            <span>Music</span>
                                        </li>
                                        <li className="nftMrkt_varsFct_cntLstItm">
                                            <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_varsFct_lstItmImg5.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                            <span>Sports</span>
                                        </li>
                                        <li className="nftMrkt_varsFct_cntLstItm">
                                            <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_varsFct_lstItmImg6.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                            <span>Photographs</span>
                                        </li>
                                        <li className="nftMrkt_varsFct_cntLstItm">
                                            <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_varsFct_lstItmImg7.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                            <span>Domains</span>
                                        </li>
                                        <li className="nftMrkt_varsFct_cntLstItm">
                                            <img src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_varsFct_lstItmImg8.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                            <span>Metaverse</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="nftMrkt_varsFct_cntRgt">
                                    <img className="nftMrkt_varsFct_cntRgtImg" src={new URL("../../../image/NFTMarketplaceNew/nftMrkt_varsFct_lstRgtImg.webp", import.meta.url)} alt='nft-marketplace-development-service' />
                                </div>
                            </div>
                        </div>
                    </div>
                </article>

                {/* section 7 */}

                <article className='nftMrkt_why_sct nftMrkt_commn_sct'>
                    <div className='nftMrkt_why_cont nftMrkt_commn_cont primary__landing__container'>
                        <div className='nftMrkt_why_wrp'>
                            <h2 className='nftMrkt_common_title'>
                                <span>Why Beleaf Chosen </span> as a Professional NFT Marketplace Development Company
                            </h2>
                            <p className='nftMrkt_common_desp'>
                                Developing an NFT Marketplace can be a complex task, But developing it with the help of an adroit team can 
                                help you develop a secure and scalable NFT marketplace platform. Beleaf Technologies is a professional NFT 
                                marketplace development company, with expertise in blockchain technology, smart contract, security, 
                                user experience design, advanced functionalities, and features. We offer the best NFT marketplace development 
                                solution that can maximize your chance of success in the market.
                            </p>
                            <button className='nftMrkt_common_Btn2 nftMrkt_contactUs_Btn' data-toggle="modal" data-target="#myModal">
                                        <span className='nftMrkt_common_Btn2Txt'>Contact Us</span>
                                        <span className='nftMrkt_common_Btn2Icon'>
                                            <img className="nftMrkt_common_Btn2Icon1" src={new URL("../../../image/NFTMarketplaceNew/btn2Arrow1.webp",import.meta.url)} alt="" />
                                            <img className="nftMrkt_common_Btn2Icon2" src={new URL("../../../image/NFTMarketplaceNew/btn2Arrow2.webp",import.meta.url)} alt="" />
                                        </span>
                                    </button>
                        </div>
                    </div>
                </article>

                

            </main>

            <ServiceFooter />
        </>
    )
}

export default NFTMarketplace